import React, { useState, useEffect } from "react";
import { BsChevronLeft, BsChevronRight } from "react-icons/bs";
import moment from "moment";

import "./DatePicker.scss";

interface DatePickerProps {
  initialDate?: Date | null;
  onDateChange?: (date: Date) => void;
  dateFormat?: string; // Optional format for displaying the date
}

export const DatePicker: React.FC<DatePickerProps> = ({
  onDateChange,
  initialDate = null,
  dateFormat = "MMM D, YYYY",
}) => {
  const [selectedDate, setSelectedDate] = useState(
    initialDate ? moment(initialDate).startOf("day") : moment().startOf("day")
  );

  // Format the date for display using moment
  const formatDate = (): string => {
    return selectedDate.format(dateFormat);
  };

  useEffect(() => {
    if (onDateChange) {
      onDateChange(selectedDate.toDate());
    }
  }, [selectedDate, onDateChange]);

  const handlePreviousDay = (): void => {
    setSelectedDate(moment(selectedDate).subtract(1, "days"));
  };

  const handleNextDay = (): void => {
    setSelectedDate(moment(selectedDate).add(1, "days"));
  };

  return (
    <div className="date-picker-component">
      <div className="icon-container" onClick={handlePreviousDay}>
        <BsChevronLeft className="icon" />
      </div>

      <div className="date-text">{formatDate()}</div>

      <div className="icon-container" onClick={handleNextDay}>
        <BsChevronRight className="icon" />
      </div>
    </div>
  );
};
